<template>
  <div class="card-control-section basic_card_layout card-layout">
    <div v-for="(item, index) of serviceList" class="col-xs-6 col-sm-6 col-lg-4 col-md-6" style="margin-top: 10px; margin-bottom: 10px">
      <div tabindex="0" class="e-card">
        <div class="e-card-content">
          <div class="text-align" style="height:42px; border-bottom:1px solid #eee; ">
            <div style="float:left; line-height: 40px; font-size: 14px; text-indent: 5px;">{{item.name}}</div>
            <div class='h-toolbarBg'>
              <ejs-toolbar style="float:right;">
<!--                <button class="e-btn e-tbar-btn icon hero-icon hero-icon-details" title='部署实例' @click='details(item)'/>-->
<!--                <button class="e-btn e-tbar-btn icon hero-icon hero-icon-confirm" title='环境详情' @click='detailnodes(item)'/>-->
                <button class="e-btn e-tbar-btn icon hero-icon hero-icon-edit" title='修改' @click='modifyService(item)'/>
                <button class="e-btn e-tbar-btn icon hero-icon hero-icon-remove" title='删除' @click='deleteConfirm(item)'/>
              </ejs-toolbar>
            </div>
          </div>
          <div style="text-indent: 5px;line-height: 24px;">
            实例名：{{item.name}}
          </div>
          <div style="text-indent: 5px;line-height: 24px;">
            实例数：{{countList[index]}}
          </div>
          <div style="text-indent: 5px;line-height: 24px;">
            创建时间：{{formatDate(item.createTime)}}
          </div>
        </div>
      </div>
    </div>

    <div class="col-xs-6 col-sm-6 col-lg-4" style="margin-top: 10px">
      <div tabindex="0" class="e-card">
        <div class="e-card-actions k8s-bg" style="height:146px;background-position: center;text-align:center;" @click='addDialogShow'>
<!--          <button class="e-btn e-outline e-primary">-->
<!--            Add More-->
<!--          </button>-->
        </div>
      </div>
    </div>
    <CustomDialog ref='addServiceDialog' :element='devDialog.element' :styles='devDialog.styles' :messages='devDialog.messages'>
      <template v-slot:dialog-content>
        <addBSDevice ref='addService' @getServiceData="getInitData" @close="addCancel"></addBSDevice>
      </template>
    </CustomDialog>
    <CustomDialog ref='updateServiceDialog' :element='updateDialog.element' :styles='updateDialog.styles' :messages='updateDialog.messages'>
      <template v-slot:dialog-content>
        <UpdateSerDevice ref='updateService' @getServiceData="getInitData" @close="addCancel"></UpdateSerDevice>
      </template>
    </CustomDialog>
  </div>
</template>

<script>
  import CustomDialog from '../../../common/CustomDialog';
  import { EventBus } from '../../../../plugins/eventBus';
  import AddBSDevice from '@/components/deploymentManagement/runningEnvironment/BSDeviceEnviromentConfig/AddBSDevice';
  import UpdateSerDevice from '@/components/deploymentManagement/runningEnvironment/ServerEnvironment/UpdateSerDevice';

  export default {
    name: 'SPanel',
    components: {
      CustomDialog,
      AddBSDevice,
      UpdateSerDevice,
    },
    data(){
      return{
        serviceList: [], // 服务集合
        countList: [], // 实例数集合
        deleteId: '',  // 删除设备Id
        devDialog: {
          element: {
            title: this.$t('Topo.devAdd'),
            isClose: true,
            refName: this.$t('Topo.devMange'),
            buttonGroup: [
              { click: this.addCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.addSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '660px',
            height: '420px',
            visible: false,
            model: true
          },
          messages: {
            title: this.$t('Topo.devAdd')
          }
        },
        // 修改服务器弹窗
        updateDialog: {
          element: {
            title: this.$t('Topo.devModify'),
            isClose: true,
            refName: this.$t('Topo.devMange'),
            buttonGroup: [
              { click: this.updateCancel, buttonModel: { content: this.$t('Topo.cancel') } },
              { click: this.updateSubmit, buttonModel: { content: this.$t('Topo.confirm'), isPrimary: true } },
            ]
          },
          styles: {
            width: '680px',
            height: '460px',
            visible: false,
            model: true
          },
          messages: {
            title: this.$t('Topo.devAdd')
          }
        },
      }
    },
    mounted() {
      this.$loading.showLoadding(this.$t('SubscriberIms.waitTip'));
      this.getInitData();
    },
    methods: {
      // 初始化数据
      getInitData() {
        console.log('服务器初始化列表');
        const This = this;
        This.$axios.post(`/lte/ems/env/serverDevicePage`).then(response => {
          if(response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            if(response.data === undefined || response.data.resultVal === undefined){
              return;
            }
            This.serviceList = response.data.resultVal[0];
            This.countList = response.data.resultVal[1];
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
          this.$loading.hideLoadding();
        });
      },
      // 格式化日期
      formatDate(value) {
        let date = new Date(value);
        const y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? ('0' + MM) : MM;
        let d = date.getDate();
        d = d < 10 ? ('0' + d) : d;
        let h = date.getHours();
        h = h < 10 ? ('0' + h) : h;
        let m = date.getMinutes();
        m = m < 10 ? ('0' + m) : m;
        let s = date.getSeconds();
        s = s < 10 ? ('0' + s) : s;
        return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
      },
      // 打开添加弹窗
      addDialogShow() {
        this.$refs.addService.initData(false, 2);
        this.$refs.addServiceDialog.show();
        this.$refs.addService.bindValidate();
      },
      // 添加提交
      addSubmit() {
        this.$refs.addService.outputs('SD');
        this.getInitData();
      },
      // 添加取消
      addCancel() {
        this.$refs.addServiceDialog.clear();
        this.$refs.addServiceDialog.close();
        this.$refs.updateServiceDialog.clear();
        this.$refs.updateServiceDialog.close();
      },
      // 打开修改弹窗
      modifyService(item) {
        this.axios.get(`/lte/ems/topo/device/devInfoDetail/${item.id}`).then(response => {
          if (response && response.status === 200 && response.data.errorCode === 'SUCCESS') {
            const devInfo = response.data.resultVal;
            this.$refs.updateService.initData(devInfo);
            this.$refs.updateServiceDialog.show();
            this.$refs.updateService.bindValidate();
          } else {
            if (response.data.errorString) {
              EventBus.$emit('toast', { type: 'error', content: response.data.errorString });
            }
          }
        });
      },
      // 修改提交
      updateSubmit() {
        this.$refs.updateService.outputs();
      },
      // 修改取消
      updateCancel() {
        this.$refs.updateServiceDialog.clear();
        this.$refs.updateServiceDialog.close();
      },
      // 删除确认
      deleteConfirm(item) {
        this.deleteId = item.id;
        this.$layer.confirm({
          msg: this.$t('Topo.sureDel'),
          btn1: {
            msg: this.$t('Topo.cancel')
          },
          btn2: {
            msg: this.$t('Topo.confirm'),
            func: this.doDelete
          }
        });
      },
      // 删除操作
      doDelete() {
        const devId = this.deleteId;
        this.axios.get(`/lte/ems/topo/device/deleteDev/${devId}`).then(response => {
          if(response.data === undefined){
            return;
          }
          if (response.status === 200 && response.data.errorCode === 'SUCCESS') {
            EventBus.$emit('toast', {type: 'success', content: this.$t('Topo.delSuccess')});
            this.getInitData();
            return;
          } else {
            EventBus.$emit('toast', {type: 'error', content: response.data.errorString});
          }
        })
      },
    },
  }

</script>
<style scoped>

  .card-control-section.basic_card_layout .e-card {
    color: white;
  }

  .highcontrast .card-control-section.basic_card_layout .e-card {
    border: none;
  }

  .card-control-section.basic_card_layout .e-card .weather_report {
    text-align: right;
  }

  .card-control-section.basic_card_layout .col-xs-6.col-sm-6.col-lg-6.col-md-6 {
    width: 100%;
    padding: 10px;
  }

  .card-control-section.basic_card_layout .card-layout {
    margin: auto;
    max-width: 400px;
  }

  @media (min-width: 870px) {
    .card-control-section.basic_card_layout .col-xs-6.col-sm-6.col-lg-6.col-md-6 {
      width: 50%;
    }

    .card-control-section.basic_card_layout .card-layout {
      max-width: calc(100% - 40px);
    }
  }
  .e-toolbar{
    background:none!important;
  }
</style>
